import { Button } from '@zorro/design-system/v2/Button';
import { Link } from '@zorro/design-system/v2/Link';
import { GuyTypingOnLaptop2 } from '@zorro/shared/assets';
import { Container, Stack, Text } from '@zorro/web/design-system';
import { useAppRouter } from '@zorro/web/ui-utils';

import { StepHeading } from '../StepHeading';

type SomethingWentWrongProps = {
  title?: string;
  subtitle?: string;
  shouldShowSupportMessage?: boolean;
  actionButtonText?: string;
  actionButtonAction?: () => void;
};

export const SomethingWentWrong = ({
  title = 'Oops!',
  subtitle = 'Something went wrong',
  shouldShowSupportMessage = true,
  actionButtonText,
  actionButtonAction,
}: SomethingWentWrongProps) => {
  const { reloadPage } = useAppRouter();

  const handleAction = () => {
    if (actionButtonAction) {
      actionButtonAction();
    } else {
      reloadPage();
    }
  };

  return (
    <Container size="sm">
      <Stack align="center">
        <GuyTypingOnLaptop2 />

        <StepHeading title={title} subtitle={subtitle} align="center" />
        {actionButtonText && (
          <Button size="lg" onClick={handleAction}>
            {actionButtonText}
          </Button>
        )}
        {shouldShowSupportMessage && (
          <Text ta="center" mt="3rem" c="zorroGray.4">
            If the problem persists, please contact{' '}
            <Link href="mailto:support@myzorro.co" target="_blank">
              support@myzorro.co
            </Link>
          </Text>
        )}
      </Stack>
    </Container>
  );
};
